export default {
    hasLoadedMySubscriptions: state => state.mySubscriptionsInitial
}


// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/MySubscriptions/getters.js